var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgHeroSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 903,
    viewBox: "0 0 1440 903",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_506_491)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: -163.55,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.583,
    y: -163.55,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781.167,
    y: -163.55,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 945.75,
    y: -163.55,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110.33,
    y: -163.55,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1274.92,
    y: -163.55,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 1.03418,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.583,
    y: 1.03418,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781.167,
    y: 1.03418,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 945.75,
    y: 1.03418,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110.33,
    y: 1.03418,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1274.92,
    y: 1.03418,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 165.616,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.583,
    y: 165.616,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781.167,
    y: 165.616,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 945.75,
    y: 165.616,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110.33,
    y: 165.616,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1274.92,
    y: 165.616,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 330.2,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.583,
    y: 330.2,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781.167,
    y: 330.2,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 945.75,
    y: 330.2,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110.33,
    y: 330.2,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1274.92,
    y: 330.2,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 494.784,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.583,
    y: 494.784,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781.167,
    y: 494.784,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 945.75,
    y: 494.784,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110.33,
    y: 494.784,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1274.92,
    y: 494.784,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 659.366,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.583,
    y: 659.366,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781.167,
    y: 659.366,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 945.75,
    y: 659.366,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110.33,
    y: 659.366,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1274.92,
    y: 659.366,
    width: 164.583,
    height: 164.583,
    rx: 18.1609,
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 842.111C452 832.081 460.131 823.95 470.161 823.95H598.839C608.869 823.95 617 832.081 617 842.111V902.95H452V842.111Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617 842.111C617 832.081 625.131 823.95 635.161 823.95H762.839C772.869 823.95 781 832.081 781 842.111V902.95H617V842.111Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781 842.111C781 832.081 789.131 823.95 799.161 823.95H927.839C937.869 823.95 946 832.081 946 842.111V902.95H781V842.111Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946 842.111C946 832.081 954.131 823.95 964.161 823.95H1091.84C1101.87 823.95 1110 832.081 1110 842.111V902.95H946V842.111Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 842.111C1110 832.081 1118.13 823.95 1128.16 823.95H1256.84C1266.87 823.95 1275 832.081 1275 842.111V902.95H1110V842.111Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275 842.111C1275 832.081 1283.13 823.95 1293.16 823.95H1421.84C1431.87 823.95 1440 832.081 1440 842.111V902.95H1275V842.111Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.33 14.6543V147.456C1110.33 157.486 1118.46 165.617 1128.49 165.617H1256.76C1266.79 165.617 1274.92 173.748 1274.92 183.778V312.039C1274.92 322.069 1283.05 330.2 1293.08 330.2H1421.34C1431.37 330.2 1439.5 338.331 1439.5 348.361V476.623M945.75 14.6543V147.456C945.75 157.486 953.881 165.617 963.911 165.617H1092.17C1102.2 165.617 1110.33 173.748 1110.33 183.778V312.039C1110.33 322.069 1118.46 330.2 1128.49 330.2H1256.76C1266.79 330.2 1274.92 338.331 1274.92 348.361V476.623C1274.92 486.653 1266.79 494.784 1256.76 494.784H1128.49C1118.46 494.784 1110.33 486.653 1110.33 476.623V346.091L1110.17 345.018C1108.96 336.793 1101.97 330.651 1093.66 330.491L1078.55 330.2H963.911C953.881 330.2 945.75 338.331 945.75 348.361V476.623C945.75 486.653 953.881 494.784 963.911 494.784H1093.31L1097.62 495.071C1104.77 495.548 1110.33 501.491 1110.33 508.662V522.592M1110.33 508.404V641.206C1110.33 651.236 1118.46 659.367 1128.49 659.367H1256.76C1266.79 659.367 1274.92 667.498 1274.92 677.528V805.789C1274.92 815.819 1283.05 823.95 1293.08 823.95H1421.34C1431.37 823.95 1439.5 832.081 1439.5 842.111",
    stroke: "url(#paint0_linear_506_491)",
    strokeOpacity: 0.8,
    strokeWidth: 1.70259
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 903,
    width: 794,
    height: 494,
    transform: "rotate(-90 452 903)",
    fill: "url(#paint1_linear_506_491)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1375,
    y: 903,
    width: 923,
    height: 243,
    transform: "rotate(-180 1375 903)",
    fill: "url(#paint2_linear_506_491)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    width: 1062,
    height: 285,
    fill: "url(#paint3_linear_506_491)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_506_491",
    x1: 945.75,
    y1: 14.6543,
    x2: 1736.89,
    y2: 993.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0819437,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#E43436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#C471ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E43436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_506_491",
    x1: 849,
    y1: 903,
    x2: 849,
    y2: 1397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_506_491",
    x1: 1836.5,
    y1: 903,
    x2: 1836.5,
    y2: 1146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_506_491",
    x1: 909,
    y1: 0,
    x2: 909,
    y2: 221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755722,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_506_491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 903,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHeroSection);
export default __webpack_public_path__ + "static/media/bg-hero-section.5ca6f6c77e7970e76c50fa235abd173d.svg";
export { ForwardRef as ReactComponent };